import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=2367f40c&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=2367f40c&prod&scoped=true&lang=css"
import style1 from "./Invoice.vue?vue&type=style&index=1&id=2367f40c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2367f40c",
  null
  
)

export default component.exports